import type { AxiosError } from 'axios'
import axios from 'axios'
import { reportErrorToServer } from './error-logger'

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error: AxiosError) => {
    reportErrorToServer(error)
    throw error
  },
)

export { instance as apiClient }
